export const BREAKPOINTS = {
  isMobile: "(min-width: 0px) and (max-width: 62rem)",
  isMedium: "(min-width: 62rem) and (max-width: 75rem)",
  isLarge: "(min-width: 75rem)"
};
